<template>
	<div class="notice">
		<img src="@/static/img/head/speaker.webp" alt="speaker" width="16px" />
		<marquee behavior="scroll" scrolldelay="150" direction="left">
			<span v-for="(item, index) in announcement" :key="index">{{ item.title }}{{ item.money }}元</span>
		</marquee>
	</div>
</template>

<script>
export default {
	name: "notice",
	data() {
		return {
			// 中奖公告
			announcement: [
				{ title: "恭喜j5***a0在 澳洲幸运5 赢得", money: 1000 },
				{ title: "恭喜1****a5在 奇趣腾讯分分彩 赢得", money: 58154 },
				{ title: "恭喜at***ee在 福彩3D 赢得", money: 2360 },
				{ title: "恭喜c****e1在 极速28 赢得", money: 4860 },
				{ title: "恭喜52***ee在 奇趣腾讯分分彩 赢得", money: 10060 },
				{ title: "恭喜h***sa*在 幸运分分彩 赢得", money: 8480 },
				{ title: "恭喜j5***a0在 澳洲幸运5 赢得", money: 1000 },
				{ title: "恭喜1****a5在 奇趣腾讯分分彩 赢得", money: 58154 },
				{ title: "恭喜at***ee在 福彩3D 赢得", money: 2360 },
				{ title: "恭喜c****e1在 极速28 赢得", money: 4860 },
				{ title: "恭喜52***ee在 奇趣腾讯分分彩 赢得", money: 10060 },
				{ title: "恭喜h***sa*在 幸运分分彩 赢得", money: 8480 },
				{ title: "恭喜j5***a0在 澳洲幸运5 赢得", money: 1000 },
				{ title: "恭喜1****a5在 奇趣腾讯分分彩 赢得", money: 58154 },
				{ title: "恭喜at***ee在 福彩3D 赢得", money: 2360 },
				{ title: "恭喜c****e1在 极速28 赢得", money: 4860 },
				{ title: "恭喜52***ee在 奇趣腾讯分分彩 赢得", money: 10060 },
				{ title: "恭喜h***sa*在 幸运分分彩 赢得", money: 8480 },
			],
		};
	},
};
</script>

<style scoped lang="scss">
.notice {
	display: flex;
	align-items: center;
	max-width: 490px;
	padding-right: 20px;
	marquee {
		margin-left: 10px;
		span {
			color: #888;
			font-size: 12px;
			font-family: PingFangSC-Regular;
			margin-right: 20px;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/common/notice.vue